import {APPROVALS, MY_REQUESTS, PENDING_APPROVALS} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// The "Approvals" menu: one list of what I filed and one queue of what waits on me, across every
// approval document type (store's Approvals, mirrored). Pending Approvals opens each row in its
// type's review drawer, so there is no per-type approval route.
export const ApprovalsRoutes: IAppRoutes = {
  link: APPROVALS,
  childrens: [
    {
      link: MY_REQUESTS,
      element: guard(() => import('@modules/approvals/MyRequests'), [MY_REQUESTS]),
    },
    {
      link: PENDING_APPROVALS,
      element: guard(() => import('@modules/approvals/PendingApprovals'), [PENDING_APPROVALS]),
    },
  ],
}
